import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CreateBriefTemplateDto {
  creativeBriefTitle: string;
  creativeBriefContent: string;
  agencyId: string;
  businessAccountId: string;
  stepsHtml: string;
  doHtml: string;
  dontHtml: string;
  stepsPlainText: string;
  doPlainText: string;
  dontPlainText: string;
  creativeConcepts: { id: number; name: string; description: string }[];
  contentPillars: any[];
}

/** Response from creating a template (shape may include additional API fields). */
export type CreatedCreativeBriefTemplate = CreateBriefTemplateDto & {
  id: string;
};

/** Template row returned from associated-templates (matches API / entity fields). */
export interface AssociatedCreativeBriefTemplate {
  id: string;
  creativeBriefTitle: string;
  creativeBriefContent: string;
  stepsHtml: string | null;
  doHtml: string | null;
  dontHtml: string | null;
  stepsPlainText: string | null;
  doPlainText: string | null;
  dontPlainText: string | null;
  /** API entity uses `createdDate` (timestamptz). */
  createdDate?: string;
  creativeConcepts?: { id: number; name: string; description: string }[] | null;
  contentPillars?: CreateBriefTemplateDto['contentPillars'] | null;
  agencyId?: string | null;
  businessAccountId?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class CreativeBriefTemplate {
  private http = inject(HttpClient);

  createCreativeBriefTemplate(
    newTemplate: CreateBriefTemplateDto
  ): Observable<CreatedCreativeBriefTemplate> {
    const url = `${environment.shout_api.url}/creative-brief-template`;
    return this.http.post<CreatedCreativeBriefTemplate>(url, newTemplate, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  updateCreativeBriefTemplate(templateId: string, newTemplate: unknown) {
    const url = `${environment.shout_api.url}/creative-brief-template/${templateId}`;
    return this.http.put(url, newTemplate, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  getAssociatedTemplates(
    businuessAccountId: string,
    agencyId: string | undefined
  ): Observable<AssociatedCreativeBriefTemplate[]> {
    const url = `${environment.shout_api.url}/creative-brief-template/associated-templates/${businuessAccountId}/${agencyId}`;
    return this.http.get<AssociatedCreativeBriefTemplate[]>(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  deleteTemplate(templateId: string) {
    const url = `${environment.shout_api.url}/creative-brief-template/${templateId}`;
    return this.http.delete(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}
